import {
  GET_LOCATIONS,
  LOCATION_CLICK,
  LOCATION_SWIPE_LEFT,
  LOCATION_SWIPE_RIGHT,
  SET_ACTIVE_LOCATION,
  TOGGLE_MAP_VIEW,
  CLOSE_ZOOM,
  TOGGLE_SETTINGS,
  RESET_STATE
} from "../data/constants";

import { handle } from "redux-pack";

const initialState = {
  isLoading: false,
  error: null,
  isSettingOpen: false,
  view: "MAP",
  isZoomed: false,
  activeLocation: null,
  serviceCenterLocations: [
    { "id": 9, "name": "\u0645\u062d\u0627\u0643\u0645 \u062f\u0628\u064a", "lat": 24.954663, "lng": 55.02434, "measures_happiness_meter": 94, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 13, "name": "\u062c\u0645\u0627\u0631\u0643 \u062f\u0628\u064a", "lng": 55.142392, "lat": 25.123877, "measures_happiness_meter": 97.4, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 16, "name": "\u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0628\u062f\u0628\u064a", "lat": 25.050497, "lng": 55.168473, "measures_happiness_meter": 61, "entity": "\u0642\u0646\u0627\u0629 \u062a\u0642\u062f\u064a\u0645 \u062e\u062f\u0645\u0629 \u0645\u062a\u062e\u0635\u0635\u0629" },
    { "id": 29, "name": "\u0645\u062d\u0627\u0643\u0645 \u062f\u0628\u064a", "lat": 24.969603, "lng": 55.102584, "measures_happiness_meter": 35, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 23, "name": "\u062c\u0645\u0627\u0631\u0643 \u062f\u0628\u064a", "lng": 55.139646, "lat": 24.924777, "measures_happiness_meter": 75.4, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 26, "name": "\u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0628\u062f\u0628\u064a", "lat": 25.033836, "lng": 55.054063, "measures_happiness_meter": 41, "entity": "\u0642\u0646\u0627\u0629 \u062a\u0642\u062f\u064a\u0645 \u062e\u062f\u0645\u0629 \u0645\u062a\u062e\u0635\u0635\u0629" }
  ],
  cardNo: 0,
  counts: [0, 1, 2, 1, 2],
  totalCount: 3,

};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LOCATIONS:
      return handle(state, action, {
        start: prevState => ({
          ...prevState,
          isLoading: true,
          error: null
        }),
        finish: prevState => ({ ...prevState, isLoading: false }),
        failure: prevState => ({ ...prevState, error: payload }),
        success: prevState => ({
          ...prevState,
          serviceCenterLocations: payload.data.results.data,
          counts: payload.data.results.counts,
          totalCount: payload.data.results.total_count
        })
      });
    case LOCATION_CLICK:
      return {
        ...state,
        activeLocation: payload,
        isZoomed: !state.isZoomed
      };

    case LOCATION_SWIPE_LEFT:
      return {
        ...state,
        cardNo: state.cardNo + 1
      };
    case LOCATION_SWIPE_RIGHT:
      return {
        ...state,
        cardNo: state.cardNo - 1
      };

    case SET_ACTIVE_LOCATION:
      return {
        ...state,
        activeLocation: payload
      };

    case TOGGLE_MAP_VIEW:
      return {
        ...state,
        view: payload
      };
    case CLOSE_ZOOM:
      return {
        ...state,
        activeLocation: null,
        isZoomed: false
      };

    case TOGGLE_SETTINGS:
      return {
        ...state,
        isSettingOpen: !state.isSettingOpen
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};
